export default "__VITE_ASSET__DaiAxj7G__"